'use client'

import { SECOND_TO_MS } from '@/utils/constants'
import { useState } from 'react'
import { AdSlot } from 'react-dfp'
import styled from 'styled-components'
import { GPTSlotProps } from '~types/index'

const GPTSlotStyled = styled.div<{
  selector: string
  loading: string
  aspectRatio: string
  shapeSquare?: boolean
}>`
  .ant-skeleton-element {
    width: 100%;
  }
  div[id^=${(props) => props.selector}] {
    height: ${(props) => (props.loading === 'true' ? '0' : 'auto')};
  }
  iframe {
    border-radius: ${({ shapeSquare }) =>
      shapeSquare ? 0 : 'var(--spacing-borderRadius-large)'};
    aspect-ratio: ${(props) => props.aspectRatio};
  }
`

const GPTSlot = ({
  id,
  selector,
  adUnitPath,
  slotSize,
  targeting,
  fallback,
  aspectRatio,
  shapeSquare,
}: GPTSlotProps) => {
  const [loading, setLoading] = useState(!!fallback)
  const [reload, setReload] = useState(0)

  const reloadSlot = (slot: string) =>
    setTimeout(() => {
      if (typeof window === 'undefined') return
      if (window?.googletag?.pubads) {
        // eslint-disable-next-line no-unused-expressions
        window.googletag.pubads()?.refresh?.([slot])
      }
    }, SECOND_TO_MS * 2)

  return (
    <GPTSlotStyled
      loading={loading.toString()}
      selector={selector}
      aspectRatio={aspectRatio}
      shapeSquare={shapeSquare}
    >
      {loading && fallback}
      <AdSlot
        slotId={id}
        adUnit={adUnitPath}
        sizes={slotSize}
        targetingArguments={targeting}
        onSlotRender={({
          event,
        }: {
          event: { slot: string; isEmpty: boolean; size: string }
        }) => {
          const itWasLoaded = !event.isEmpty && !!event.size
          setLoading(!itWasLoaded)
          if (!itWasLoaded && reload < 3) {
            setReload((prevState) => prevState + 1)
            reloadSlot(event.slot)
          }
        }}
      />
    </GPTSlotStyled>
  )
}

export default GPTSlot
